import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import travelImg from 'images/tmp_travel_image.png'
import styles from './index.module.css'

const TravelDetail4 = () => {

	const App = useApp()
	const [tabList, setTabList] = useState(0)
	const [toggleButton, setToggleButton] = useState(false)

	const moreOpen = () => {
		setToggleButton(!toggleButton)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1">
				<div className="img-box" style={{ height: "26rem" }}>
					<img src={travelImg} alt="" />
				</div>
				<div className={styles["travel-guide"]}>
					<div className={`${styles["travel-view"]} shadow`}>
						<div className={`${styles["title-area"]} ${styles.txt}`}>
							<i className="tag tag-box tag-purple">레포츠</i>
							<div className={styles.title}>가람관광농원</div>
							<div className={styles["tag-area"]}>
								<span>#중분류</span>
								<span>#소분류</span>
							</div>
						</div>
					</div>
					<div className="shadow">
						<div className="padding pb_50">
							<div className={`${styles["list-item"]} ${styles.title}`}>
								<div>
									<span className="flex-align_center">
										<i className="icon_life icon_life_call icon mr_5" />
										전화
									</span>
									<span className={styles["btn-txt"]}>031-8078-8028</span>
								</div>
								<div>
									<span className="flex-align_center">
										<i className="icon_life icon_life_mail icon mr_5" />
										홈페이지
									</span>
									<span className={styles["btn-txt"]}>http://www.yangcheon.go.kr/</span>
								</div>
								<div>
									<span className="flex-align_center">
										<i className="icon_life icon_life_place icon mr_5" />
										주소
									</span>
									<span>서울 양천구 신정동 162-56(08104)<i className="icon icon_copy ml_10" /></span>
								</div>
							</div>
							<div className="img-box mt_20" style={{ height: "20rem" }}>
								<img src={travelImg} alt="" />
							</div>
							<div className={`${styles.content} mt_30`}>
								<p>소개</p>

								{/* 펼쳤을때 open 클래스 제거 */}
								<div className={`${styles.open} mt_10`}>럭셔리 고풍스러운호텔로서의 명성을 이어가고 있는 더 힐
									하우스 호텔은 그 시설뿐만 아니라 고객에 대한 서비스 하
									럭셔리 고풍스러운호텔로서의 명성을 이어가고 있는 더 힐
									하우스 호텔은 그 시설뿐만 아니라 고객에 대한 서비스 하
									럭셔리 고풍스러운호텔로서의 명성을 이어가고 있는 더 힐
									하우스 호텔은 그 시설뿐만 아니라 고객에 대한 서비스 하
									럭셔리 고풍스러운호텔로서의 명성을 이어가고 있는 더 힐
									하우스 호텔은 그 시설뿐만 아니라 고객에 대한 서비스 하
								</div>

								{/* 더보기 접기 */}
								<div className="flex-justify_center mt_30">
									<div className={styles.more} onClick={moreOpen}>더보기 <i className={`${styles.arrow} ${toggleButton ? styles.active : ""}`} /></div>
								</div>
							</div>
						</div>
					</div>

					<ul className="tab-round padding">
						<li onClick={() => setTabList(0)} className={tabList === 0 ? "active" : ""}>기본정보</li>
						<li onClick={() => setTabList(1)} className={tabList === 1 ? "active" : ""}>추가정보</li>
					</ul>

					{/* 기본정보 */}
					<div className="padding pt_0">
						<div className={styles["list-item"]}>
							<div>
								<span className="flex-align_center">
									<i className="icon_life icon_life_user icon mr_5" />
									수용인원
								</span>
								<span>최소 10명 이상 단체</span>
							</div>
							<div>
								<span className="flex-align_center">
									<i className="icon_life icon_life_parking icon mr_5" />
									주차시설
								</span>
								<span>있음</span>
							</div>
							<div>
								<span className="flex-align_center">
									<i className="icon_life icon_life_time icon mr_5" />
									이용시간
								</span>
								<span>월~금 시간 협의</span>
							</div>
						</div>

						<hr className="my_30" />
						<div>이용안내</div>
						<div className={`${styles["list-item"]} mt_20`}>
							<div>
								<span>규모</span>
								<span>연중개방</span>
							</div>
							<div>
								<span>체험 가능연령</span>
								<span>1999.02.02</span>
							</div>
							<div>
								<span>개장기간</span>
								<span>연중개방</span>
							</div>
							<div>
								<span>쉬는날</span>
								<span>연중개방</span>
							</div>
							<div>
								<span>예약안내</span>
								<span>연중개방</span>
							</div>
						</div>

						<hr className="my_30" />
						<div>요금정보</div>
						<div className={`${styles["list-item"]} mt_20`}>
							<div>
								<span>입장료</span>
								<span>연중개방</span>
							</div>
							<div>
								<span>주차요금</span>
								<span>연중개방</span>
							</div>
						</div>

						<hr className="my_30" />
						<div>편의시설</div>
						<div className={`${styles["list-item"]} mt_20`}>
							<div>
								<span>유모차 대여 정보</span>
								<span>없음</span>
							</div>
							<div>
								<span>애완동물 동반 가능 정보</span>
								<span>없음</span>
							</div>
							<div>
								<span>신용카드 기능 정보</span>
								<span>없음</span>
							</div>
						</div>

						<div className={`${styles["detail-box"]} mt_40 mb_0`}>
							<div className={styles["list-item"]}>
								<div>
									<span>문의 및 안내</span>
									<span>양천구청 공원녹지과<br />02-2620-3576</span>
								</div>
							</div>
						</div>
					</div>

					{/* 추가정보 */}
					<div className="padding pt_0">
						<div className="slider">
							<ul>
								<li>
									<div className="img-box" style={{ height: "20rem" }}>
										<img src={travelImg} alt="" />
									</div>
								</li>
							</ul>
							<div className="flex-justify_center mt_10">
								<div className="pagination">
									<span>1</span>/<span>6</span>
								</div>
							</div>
						</div>
						<hr className="my_30" />
						<div className={`${styles["list-item"]} ${styles.title}`}>
							<div className={styles.block}>
								<span>제목</span>
								<span>내용내용내용내용내용내용내용내용내용내용내용내용내용
									내용내용내용내용내용내용내용내용내용내용내용내용내용
									내용내용내용내용내용내용내용내용내용내용내용내용내용
									내용내용내용내용
								</span>
							</div>
							<div className={styles.block}>
								<span>관광코스안내</span>
								<span>3코스, 안양천(신정교-오금교) - 어린이교통공원 - 갈산도
									서관 - 갈산근린공원 - 향림사 - 계남공원
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>


			<div className="flex-shrink_0 padding">
				<div className={styles["guide-bottom"]}>한국관광공사에서 받아오는 정보입니다.</div>
			</div>
		</div>
	)
}

export default TravelDetail4